export class VerificationModel {

    public documentIssueDate: string;
    public documentIssuedBy: number;
    public documentNo: string;
    public documentValidDate: string;
    public note: string;
    public pepId: number;
    public personalNo: string;
    public statusId: number;
    public statusUpdatedBy: string;
    public noteUpdatedBy: string;

    constructor(obj?: any) {
        this.documentIssueDate  = obj && obj.documentIssueDate  || '';
        this.documentIssuedBy   = obj && obj.documentIssuedBy   || null;
        this.documentNo         = obj && obj.documentNo         || '';
        this.documentValidDate  = obj && obj.documentValidDate  || '';
        this.note               = obj && obj.note               || '';
        this.pepId              = obj && obj.pepId              || null;
        this.personalNo         = obj && obj.personalNo         || '';
        this.statusId           = obj && obj.statusId           || null;
        this.statusUpdatedBy    = obj && obj.statusUpdatedBy    || '';
        this.noteUpdatedBy      = obj && obj.noteUpdatedBy      || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/verification.model.ts